import React from 'react'
import { SxProps } from '@mui/material'
import { formatCurrency } from './formatNumbers'
import { ListPageDateCell } from '../components/common/ListPageCells'

export const chipBudgetStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  padding: '3px 10px',
  borderRadius: 6,
  background: 'linear-gradient(135deg, #eef1fb 0%, #dce4f5 100%)',
  border: '1px solid #b8c8e8',
  color: '#2c3e7a',
  fontWeight: 700,
  fontSize: 13,
  fontVariantNumeric: 'tabular-nums',
  letterSpacing: '0.01em',
  whiteSpace: 'nowrap',
}

export const renderDateChip = (
  dateStr: string | undefined,
  locale: string
): React.ReactNode => <ListPageDateCell value={dateStr} locale={locale} />

export const renderBudgetChip = (
  value: number,
  currency: string | undefined,
  locale: string
): React.ReactNode => (
  <span style={chipBudgetStyle}>
    {formatCurrency(value ?? 0, currency ?? 'USD', {
      locale,
      useIntl: true,
    })}
  </span>
)

/** Start-aligned column for amounts, scores and counts, matching the other captions. */
export const numericColumn = (minWidth = 150) => ({
  headerAlign: 'left' as const,
  align: 'left' as const,
  minWidth,
  cellClassName: 'incyia-num',
})

export const tableGridSx: SxProps = {
  minWidth: 900,
  '& .MuiDataGrid-cell': {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
}
